import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Tabs, Tab, TabPanel, TabList } from '@mui/joy';
import List from './List';
import CapabilityMatrix from './CapabilityMatrix';

const Default = () => {
    const { t } = useTranslation();
    const [tabValue, setTabValue] = useState(0);

    return (
        <Tabs
            value={tabValue}
            onChange={(e, newValue) => setTabValue(newValue)}
            sx={{ background: 'transparent' }}
            className="mtska-content-tab-wrapper"
        >
            <TabList className="mtska-content-tab-list">
                <Tab className="mtska-content-tab">{t('List')}</Tab>
                <Tab className="mtska-content-tab">{t('Capabilities matrix')}</Tab>
            </TabList>
            <TabPanel value={0} sx={{ padding: '10px 0' }} className="mtska-content-tab-panel">
                <List />
            </TabPanel>
            <TabPanel value={1} sx={{ padding: '10px 0' }} className="mtska-content-tab-panel">
                <CapabilityMatrix />
            </TabPanel>
        </Tabs>
    );
};

export default Default;


